module.exports = require('gl-quat/slerp')